export var deprecatedSearchBarTheme = {
  baseStyle: _ref => {
    var {
      value,
      isTyping,
      isHover
    } = _ref;
    return {
      container: {
        display: 'flex',
        height: '40px',
        isolation: 'isolate',
        position: 'relative',
        borderBottom: 'none',
        borderRadius: 'l',
        transition: 'background-color 0.1s ease-in-out, color 0.1s ease-in-out',
        shadow: 0,
        bg: 'neutral.lighter',
        _hover: {
          shadow: value ? 0 : 500,
          bgColor: 'neutral.white'
        },
        _focus: {
          shadow: isTyping ? 400 : 500,
          bgColor: 'neutral.white'
        },
        _active: {
          shadow: 400
        },
        _disabled: {
          shadow: 0,
          bgColor: 'neutral.lighter'
        }
      },
      field: {
        height: '100%',
        padding: 'none',
        borderBottom: 'none',
        position: 'relative',
        color: 'neutral.black',
        textStyle: 'body3',
        paddingLeft: 's',
        _hover: {
          borderBottom: 'none',
          _disabled: {
            _placeholder: {
              color: 'neutral.dark'
            }
          }
        },
        _focus: {
          borderBottom: 'none',
          _placeholder: {
            color: 'neutral.dark'
          }
        },
        _disabled: {
          borderBottom: 'none',
          cursor: 'not-allowed',
          color: 'neutral.dark',
          _placeholder: {
            color: 'neutral.dark'
          }
        },
        _placeholder: {
          color: isHover ? 'neutral.dark' : 'neutral.dark'
        }
      }
    };
  }
};
//# sourceMappingURL=DeprecatedSearchBar.theme.js.map